import { render, staticRenderFns } from "./AlertSunshine.vue?vue&type=template&id=1386f010"
import script from "./AlertSunshine.vue?vue&type=script&lang=js"
export * from "./AlertSunshine.vue?vue&type=script&lang=js"
import style0 from "./AlertSunshine.vue?vue&type=style&index=0&id=1386f010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports